import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {FileUploader} from "ng2-file-upload";
import {Router} from "@angular/router";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {LoadingService} from "../../services/LoadingService";
import {ToastService} from "../../services/Toast.service";
import {Session} from "../../services/Session";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {TAX_PLANNING_TYPES} from "../../constants/tax-planning.constants";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";

declare const _: any;

@Component({
  selector: 'app-client-select-create',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent],
  templateUrl: './client-select-create.component.html'
})
export class ClientSelectCreateComponent {
  @Input() clientsList: Array<any> = [];
  @Input() uploader: FileUploader;
  @Input() uploadSourceId: any;
  
  @Output() onClientSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClientCreated: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onUpload: EventEmitter<void> = new EventEmitter<void>();

  org: string = Session.getOrg();
  user: any = Session.getUser().id;
  
  client: any = {
    defaultYear: '',
    relatedParties: [],
    status: 'Draft',
    filingStatus: 'Single'
  };
  
  filingStatusList: Array<any> = [
    {name: 'Single'},
    {name: 'MFJ'},
    {name: 'MFS'},
    {name: 'Head of Household'},
    {name: 'Estate'},
    {name: 'Trust'}
  ];
  
  years: Array<any> = [];
  types: Array<any> = TAX_PLANNING_TYPES;
  
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  constructor(
    private taxPlanningService: TaxPlanningService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private _router: Router
  ) {
    this.fillYears();
    this.client.defaultYear = new Date().getFullYear();
  }

  fillYears() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 5; i++){
      this.years.push({id: i.toString(), name: i.toString()});
    }
  }

  onClientSelect(client) {
    if (client && client.id) {
      this.getClient(client.id);
    }
  }

  getClient(clientId){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClient(this.org, this.user, clientId, false)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.client = response;
        this.client.filingStatus = (this.client.filingStatus) ? this.client.filingStatus : 'Single';
        this.client.defaultYear = (this.client.defaultYear) ? this.client.defaultYear : new Date().getFullYear();
        this.onClientSelected.emit(this.client);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get client data');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get client data');
        }
      });
  }

  onFilingSelect(status) {
    this.client.filingStatus = status.name;
  }

  setYear($event, type?) {
    if (type && type === 'planYear') {
      this.client['defaultYear'] = $event.id;
    }
  }

  setType($event, relatedParty){
    relatedParty.type = $event.name;
  }

  removeRelatedParty(index){
    this.client.relatedParties.splice(index, 1);
  }

  addRelatedParty(){
    this.client.relatedParties.push({});
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  appendIndyRelatedParty(){
    let indyClient = '';
    if (this.client.firstName){
      indyClient += this.client.firstName;
    }
    if (this.client.lastName){
      indyClient += ` ${this.client.lastName}`;
    }
    const defaultIndy = _.find(this.client.relatedParties, {default: true});
    if (defaultIndy){
      defaultIndy.name = indyClient;
    } else{
      this.client.relatedParties.push({
        name: indyClient,
        type: '1040',
        default: true
      });
    }
  }

  validateData(){
    if (!this.client.planName){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Plan Name');
      return false;
    }
    if (!this.client.firstName){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter First Name');
      return false;
    } else if (!this.client.lastName){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Last Name');
      return false;
    }
    return true;
  }

  uploadFile() {
    if(this.validateData()) {
      this.onUpload.emit();
    }
  }

  saveClient() {
    if (this.validateData()){
      this.client['id'] = this.uploadSourceId;
      this.client['labels'] = [];
      this.client['thirdParties'] = [];
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.createClient(this.org, this.user, this.client).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Client created successfully');
        this.onClientCreated.emit(response);
        this._router.navigate(['tax-planning', 'clients', 'draft']);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          const message = error.message ? error.message : 'Failed to create client';
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to create client');
        }
      });
    }
  }

  // Public method to get client data (called by parent after upload completes)
  getClientData() {
    return this.client;
  }

  scrollToBottom(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    }
  }

  cancel() {
    this.onCancel.emit();
  }
}

